/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  width: '288px',
  height: '100%',
  display: 'flex',
  columnGap: theme.spacing(4),
  padding: theme.spacing(1, 0),
}));

export const MainTextBox = styled(Box)(() => ({
  width: '100%',
}));

export const MainText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  cursor: 'pointer',
  textOverflow: 'unset !important',
  overflow: 'unset !important',
  whiteSpace: 'unset !important',
}));

export const ValueBox = styled(Box)(({theme}) => ({
  flexShrink: 0,
  width: '54px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  display: 'flex',
  justifyContent: 'flex-end',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'right',
}));
